import { Button, InputField } from "../../components";
import { useNavigate } from "react-router-dom";
import "../auth/Auth.scss";
import { generateResponsiveStyle } from "../../utils/AuthModalStyle";
import { toggleAuthModal } from "../../reducers/generalSlice";
import { useAppDispatch } from "../../hooks/store";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { usePostForgotPasswordMutation } from "../../service/Auth";
import { useFormik } from "formik";
import * as Yup from "yup";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import { Loader, errorToast, setToStorage, successToast } from "../../helpers";
import { Dispatch, SetStateAction } from "react";

type Props = {
  closeModal: () => void;
  setEmailValue: Dispatch<SetStateAction<string>>;
};

const ForgotPassword = ({ closeModal, setEmailValue }: Props) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const style = generateResponsiveStyle();
  const [postForgotPassword, { isLoading }] = usePostForgotPasswordMutation();

  const handleSubmit = () => {
    closeModal();
    dispatch(
      toggleAuthModal({
        isAuthModalVisible: true,
        ModalType: "verification",
      })
    );
  };
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("Email is required!")
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          "Enter a valid email address!"
        ),
    }),
    onSubmit: async (values) => {
      formik.setSubmitting(true);
      let data = {
        key: formik.values.email,
      };

      try {
        let encryptedBody = generateEncryptedKeyBody(data) as CommonBody;
        const response = await postForgotPassword(encryptedBody).unwrap();
        if (response?.statusCode === 200) {
          setEmailValue(formik.values.email);
          successToast(response?.message || "");
          closeModal();
          dispatch(
            toggleAuthModal({
              isAuthModalVisible: true,
              ModalType: "verification",
            })
          );
        }
      } catch (error: any) {
        errorToast(error?.data?.message || "");
        console.log(error);
      }
    },
  });

  return (
    <div>
      <div className="AuthWrap">
        <Loader isLoad={isLoading} />
        <div className="cross ">
          {/* <KeyboardBackspaceIcon onClick={()=>}/> */}
          <CloseIcon onClick={() => closeModal()} />
        </div>
        <h2>Forgot password?</h2>
        <p>
          Enter your email here
          {/* <span>admin@apptunix.com</span> */}
        </p>
        <form onSubmit={formik.handleSubmit}>
          <InputField
            placeholder="Email Id"
            name="email"
            id="email"
            value={formik.values.email}
            onChange={(val) => {
              if (val.target.value === " " || val.target.value === ".") {
              } else {
                formik.handleChange(val);
              }
            }}
            onBlur={formik.handleBlur}
            helperText={formik.touched.email && formik.errors.email}
          />

          <Button
            value="Next"
            // onClick={handleSubmit}
          />
        </form>
        <div className="blacK" />
      </div>
    </div>
  );
};

export default ForgotPassword;
